// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"Clock_buttonsContainer__e1q3F","clock":"Clock_clock__GIQPu","watch":"Clock_watch__ESRh3","more":"Clock_more__lilfk"};